import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { AdminAttributeGroupsComponent } from '../admin-attribute-groups/admin-attribute-groups.component';
import { AdminAttributesComponent } from '../admin-attributes/admin-attributes.component';
import { AdminConnectorsComponent } from '../admin-connectors/admin-connectors.component';
import { AdminMaintenancesComponent } from '../admin-maintenances/admin-maintenances.component';
import { AdminToolsComponent } from '../admin-tools/admin-tools.component';

@Component({
  selector: 'app-admin-others',
  templateUrl: './admin-others.component.html',
  styleUrls: ['./admin-others.component.scss'],
  standalone: true,
  imports: [
    MatTabsModule,
    AdminConnectorsComponent,
    AdminMaintenancesComponent,
    AdminAttributesComponent,
    AdminAttributeGroupsComponent,
    AdminToolsComponent
  ]
})
export class AdminOthersComponent {}
